import { useReminderUpdateMutation } from "web_myplann/Api/Reminders/useReminderUpdateMutation";
import { getReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import { mapReminderToFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { useReminderForm } from "web_myplann/Reminders/Hooks/useReminderForm";
import type {
	Reminder,
	ReminderEntity,
} from "web_myplann/Reminders/Types/ReminderTypes";

type UseReminderEditFormProps = {
	entity: ReminderEntity;
	reminder: Reminder;
	onSuccess: () => void;
};

export const useReminderEditForm = ({
	entity,
	reminder,
	onSuccess,
}: UseReminderEditFormProps) => {
	const { mutate: updateReminder, isPending } = useReminderUpdateMutation();

	const entityConfig = getReminderEntityConfig(entity.type);

	const { form } = useReminderForm({
		entityConfig,
		templates: [],
		validTo: entity.validTo,
		initialModel: mapReminderToFormModel(reminder, entityConfig),
	});

	const submit = form.handleSubmit((model) => {
		updateReminder({ id: reminder.id, model }, { onSuccess });
	});

	return {
		form,
		submit,
		entityConfig,
		isSubmitting: isPending,
	};
};
